export default "__VITE_ASSET__ClYEkiGA__"